import { isLocalhost } from '../modules/utilities';

const QUICK_VIEW_URL = '/maa-api/community/v1/quick-view/';

export const getQuickViewDataById = async (id = '') => {
  if (isLocalhost()) {
    return testData;
  }
  return fetch(window.location.origin + QUICK_VIEW_URL + id, {
    credentials: 'include',
  })
    .then(response => response.json())
    .then(response => {
      if (response.success !== true) {
        console.error('API error occurred');
        return {};
      }
      return response;
    });
}

const testData = {
  "success": true,
  "quickView": {
    "Id": "611790",
    "Name": "MAA Gardens",
    "Address": "1020 Lenox Park Blvd NE",
    "AvailableApartments": [
      0,
      1,
      2,
      3
    ],
    "Description": "Tour our pet-friendly luxury apartments at MAA Gardens. Rent starts at ${MinRent} for 1-3 bedroom units. Amenities include a fitness center and a yoga studio.\n",
    "Amenities": [
      {
        "Icon": "icon-24hr-fitness-center",
        "Name": "24/hr Fitness Center"
      },
      {
        "Icon": "icon-pool",
        "Name": "Pool"
      },
      {
        "Icon": "icon-tennis",
        "Name": "Tennis"
      },
      {
        "Icon": "icon-on-site-recycling",
        "Name": "On-site Recycling"
      },
      {
        "Icon": "icon-grill-and-picnic-area",
        "Name": "Grill & Picnic Area"
      },
      {
        "Icon": "icon-in-unit-laundry",
        "Name": "In unit Laundry"
      }
    ],
    "PageUrl": "/georgia/atlanta/test-maa-gardens/",
    "PhoneNumber": "(404) 390-2146",
    "ScheduleTourUrl": "/pages/page-tiles.html?prop_exp=tour",
    "Coordinates": {
      "Lat": 33.84997,
      "Lon": -84.3505
    },
    "Images": {
      "Bathrooms": [
        "/assets/img/communities-preview.png",
        "/assets/img/apartment-tour-image.jpg"
      ],
      "Outdoors": [
        "/assets/img/image-7.png"
      ],
      "Kitchen": [
        "/assets/img/image-7.png"
      ],
      "Qwe": [
        "/assets/img/image-7.png"
      ]
    },
    "IsCompare": true,
    "IsSaved": true
  },
  "labels": {
    "ViewCommunity": "View Community",
    "CallUs": "Call us",
    "CallUsMobile": "Call Us Mobile",
    "Favorite": "Favorite",
    "ScheduleATour": "Schedule Tour",
    "Compare": "Compare",
    "ExpandMap": "Expand Map",
    "CollapseMap": "Collapse Map"
  }
};



// WEBPACK FOOTER //
// ./src/js/api/quick-view.js